// Floor sale, step 5: the bill is at the till.
import React from "react";
import { formatMoney } from "../../../../utils/fashion/money";
import { Header } from "./FloorParts";
import cwSuiteLogo from "../../../../assets/images/cwsuite-logo.png";

export default function FloorDone({ result, tillData, onNew }) {
  const { documentno, total, count, customerName, consent, consentStatus } = result || {};
  const answer = consent ? "agreed" : "not agreed";
  return (
    <>
      <Header>
        <b className="fp-fl-mk">Sent to the till</b>
      </Header>
      <div className="fp-fl-body fp-fl-done" role="status">
        <span className="fp-fl-tick" aria-hidden="true">
          ✓
        </span>
        <h1 className="fp-fl-disp">{documentno ? `Sent to the till as ${documentno}` : "Sent to the till"}</h1>
        <p className="fp-fl-mute">
          <span className="fp-num">{count}</span> {count === 1 ? "item" : "items"} · <span className="fp-num">{formatMoney(total, tillData)}</span>
          {customerName ? ` · ${customerName}` : ""}
        </p>
        <p>At any till, open Parked bills, then From the floor, and open this bill to take the payment and print the receipt.</p>
        {customerName && (
          <p className="fp-fl-hint">
            {consentStatus === "saved"
              ? `Offers on WhatsApp: ${answer}. Saved to ${customerName}.`
              : consentStatus === "unsaved"
                ? `Offers on WhatsApp: ${answer}. Not saved to the customer yet; save it at the till once back online.`
                : `Offers on WhatsApp: ${answer}.`}
          </p>
        )}
        <div className="fp-fl-brand">
          <span>Powered by</span>
          <img src={cwSuiteLogo} alt="CW Suite" width="94" height="14" />
        </div>
      </div>
      <footer className="fp-fl-ft">
        <button type="button" className="fp-fl-btn fp-fl-pri fp-fl-wide" onClick={onNew}>
          New sale
        </button>
      </footer>
    </>
  );
}
